export const CONTENT_TYPE = {
  PDF: 'application/pdf',
  WORD: 'application/msword',
  POWERPOINT: 'application/vnd.ms-powerpoint',
  SPREAD_SHEET:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  EXCEL: 'application/vnd.ms-excel',
  MACRO_SHEET: 'application/vnd.ms-excel.sheet.macroEnabled.12',
};
